import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state = {
  presentation: [],
  aitopic: [],
  quiz: [],
  intake: [],
  searching: {
    presentation: {
      values: [],
      total: 0,
    },
    quiz: {
      values: [],
      total: 0,
    },
    intake: {
      values: [],
      total: 0,
    },
    aitopic: {
      values: [],
      total: 0,
    },
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
